import { Injectable } from '@angular/core'
import { LocalStorageService } from '@mistergreen/shared/angular-injectables/local-storage/local-storage.service'

@Injectable({
    providedIn: 'root',
})
export class PromoCodeService {
    // promoCode$: ReplaySubject<{ key: string; value: string | null }>; // If in the future we want to use more scalable solution
    // for Promotion codes, then we should consider using NgRx Store
    constructor(private localStorageService: LocalStorageService) {}

    setPromoCode(key: string, value: string | null) {
        this.localStorageService.setItem(`promo_code_${key}`, value)
    }

    removePromoCode(key: string) {
        this.localStorageService.removeItem(`promo_code_${key}`)
    }

    getPromoCode(key: string) {
        return this.localStorageService.getItem(`promo_code_${key}`)
    }
}
